export {
  useProgrammaticScrollDetector,
  markScrollAsProgrammatic,
  default as scrollDetector,
} from './programmatic-scroll-detector'
